import React from 'react';

// Company name / exhibitor registration no. line shown under a notification subject,
// in both the header dropdowns and the "view all" drawer.
const NotificationMeta = ({ notification }) => {
    const companyName = notification?.companyName;
    const exhRegistrationNo = notification?.exhRegistrationNo;
    if (!companyName && !exhRegistrationNo) return null;

    return (
        <div className="notification-item-meta">
            {companyName}
            {companyName && exhRegistrationNo ? ' • ' : ''}
            {exhRegistrationNo}
        </div>
    );
};

export default NotificationMeta;
